<!-- tabela -->
<div *ngIf="resultadoAvaliacaoService.resultado$ | async as resultado">
	<p class="text-semi-bold mt-2">Total de avaliações institucionais encontradas: {{ resultado.page?.totalElements }}</p>

	<p-table
		#tabelaResultadoAvaliacaoInstitucional
		[value]="resultado.content!"
		[paginator]="true"
		[lazy]="true"
		[lazyLoadOnInit]="false"
		(onLazyLoad)="lazyLoadging($event)"
		[rows]="5"
		[rowsPerPageOptions]="[5, 10, 20, 25, 30]"
		[showCurrentPageReport]="true"
		[totalRecords]="resultado.page?.totalElements!"
		currentPageReportTemplate="Exibindo {first} até {last} dos {totalRecords} elementos"
		data-cy="tabela-resultados-avaliacao-institucional"
		*ngIf="resultado.page?.totalElements; else nenhumResultado"
		sortField="ai.ciclo.numeroCiclo"
	>
		<ng-template #header>
			<tr>
				<th style="width: 50%" pSortableColumn="ai.ciclo.numeroCiclo" id="ciclo">
					Período Avaliativo <p-sortIcon field="ai.ciclo.numeroCiclo" />
				</th>
				<th style="width: 30%" pSortableColumn="ai.alcance" id="alcance">Alcance <p-sortIcon field="ai.alcance" /></th>
				<th style="width: 20%" id="acoes">Ações</th>
			</tr>
		</ng-template>

		<ng-template #body let-resultadoAvaliacao>
			<tr>
				<td headers="ciclo">
					<span class="p-column-title">Período Avaliativo</span>
					{{ resultadoAvaliacao.numeroCiclo }} - {{ resultadoAvaliacao.dataInicioAvaliacao | date: 'dd/MM/yyyy' }} - {{
					resultadoAvaliacao.dataFimAvaliacao | date: 'dd/MM/yyyy'}}
				</td>
				<td headers="alcance">
					<span class="p-column-title">Alcance</span>
					{{ resultadoAvaliacao.alcance }}
				</td>
				<td headers="acoes">
					<span class="p-column-title">Ações</span>
					<a
						aria-label="Alterar alcance da avaliação institucional"
						href="javascript:void(0)"
						(click)="alterarAlcance(resultadoAvaliacao)"
						[attr.disabled]="!resultadoAvaliacao.emAvaliacao ? true : null"
					>
						<i class="fas fa-edit"></i>
					</a>
				</td>
			</tr>
		</ng-template>
	</p-table>

	<!-- modal alterar alcance -->
	<sgp-form-alterar-alcance
		#formAlterarAlcance
		[exibir]="exibirModalAlterarAlcance"
		(fechar)="exibirModalAlterarAlcance = false"
		(alcanceAlterado)="atualizarAlcanceNaTabela($event)"
	></sgp-form-alterar-alcance>

	<!-- nenhum resultado -->
	<ng-template #nenhumResultado>
		<sgp-nenhum-resultado [exibir]="true" />
	</ng-template>
</div>
